import { configs } from '@hero/configs';
import { API_ERRORS } from '@hero/constants';
import { ROUTE_PATHS } from '@hero/routes';

function getBasePath(mainUrl) {
  let baseUrl = configs.appBaseUrl + mainUrl;
  baseUrl = baseUrl.replace('//', '/');
  return baseUrl;
}

function isExcludedError(errorObject) {
  const excludeErrors = {
    [getBasePath(ROUTE_PATHS?.SIGN_IN)]: ['UserNotFound'],
    [getBasePath(ROUTE_PATHS?.VALIDATE)]: ['InvalidUserVerificationCode']
  };

  return excludeErrors[window.location.pathname]?.includes(errorObject?.type);
}

function getErrorData(err) {
  const apiError = API_ERRORS[err?.type || err] || API_ERRORS.Default;

  if (!apiError.title) {
    return {
      title: err?.message,
      message: err?.stack,
      type: 'toast'
    };
  }

  return {
    ...apiError,
    type: apiError.type || 'toast'
  };
}

export { getBasePath, getErrorData, isExcludedError };
